/**
 * @ngdoc directive
 * @name calendar
 *
 * @description
 * Calendar component
 */
module.directive('calendar', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            reservations: '=',
            selectedReservation: '='
        },
        controller: ['$scope', 'moment', 'tools', function($scope, moment, tools) {
            $scope.tools = tools;

            // Display month only if is different than the previous element's one
            $scope.isMonthVisible = function(dateCurrent, datePrevious) {
                return datePrevious ? moment(dateCurrent).format('MMMM YYYY') !== moment(datePrevious).format('MMMM YYYY') : true;
            };

            $scope.selectDate = function(reservation) {
                $scope.selectedReservation = reservation;
            };
        }],
        templateUrl: 'src/components/calendar/calendar.html'
    };
});
